module.exports = __webpack_public_path__ + "static/media/Book-Diary-Pen.02a14714.jpg";